import { useState, useEffect } from 'react';
import { useAuth } from '../context/AuthContext';

/**
 * Outlet and visit entry are only open between today's punch in and punch out
 * (KEYNOTE 15/16). The backend enforces this on POST /outlets and POST /visits;
 * this hook mirrors the rule so the form can say why before anything is typed.
 *
 * Admins never punch, so they are always allowed.
 */
export const useAttendanceGate = () => {
  const { api, isAdmin } = useAuth();
  const [state, setState] = useState({ loading: true, allowed: false, reason: null, punchOutTime: null });

  useEffect(() => {
    if (isAdmin) {
      setState({ loading: false, allowed: true, reason: null, punchOutTime: null });
      return undefined;
    }

    let cancelled = false;
    api.get('/attendance/today')
      .then((res) => {
        if (cancelled) return;
        const { punched_in: punchedIn, punched_out: punchedOut, attendance } = res.data;
        if (!punchedIn) {
          setState({ loading: false, allowed: false, reason: 'not-punched-in', punchOutTime: null });
        } else if (punchedOut) {
          const time = attendance?.punch_out?.time;
          setState({
            loading: false,
            allowed: false,
            reason: 'punched-out',
            punchOutTime: time ? time.slice(11, 16) : null,
          });
        } else {
          setState({ loading: false, allowed: true, reason: null, punchOutTime: null });
        }
      })
      .catch(() => {
        // Fail open: the backend is the real gate, and a flaky connection should
        // not present itself to the user as "your day is closed".
        if (!cancelled) setState({ loading: false, allowed: true, reason: null, punchOutTime: null });
      });

    return () => { cancelled = true; };
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isAdmin]);

  return state;
};

export default useAttendanceGate;
